import React, { useEffect, useState } from 'react';

import { useTrialsContext } from 'contexts/TrialsContextProvider';
import useChangePage from 'hooks/useChangePage';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';
import { TRIAL_URL } from 'routes/constants';
import { VERIFY_ACCOUNT_MODAL_ROUTE } from '../../constants';
import useTrialProtectedPageGuard from '../../hooks/useTrialProtectedPageGuard';
import Imagery from './imagery';
import RoiModal from '../RoiModal';
import ProfileContent from './ProfileContent';

const Profile = () => {
  const { hasValidProfile, setNameErrors } = useTrialsContext() || {};
  const trackEvent = useTrackAmplitudeEvent('trials.profile.visited');
  const changePage = useChangePage();
  useTrialProtectedPageGuard();

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setNameErrors({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRedirect = () => {
    changePage(`${TRIAL_URL}/${VERIFY_ACCOUNT_MODAL_ROUTE}`, true);
  };

  const handleSubmit = () =>
    hasValidProfile()
      .then((isValidProfile) => {
        setIsSubmitting(false);

        if (isValidProfile) {
          trackEvent('trials.profile.nextClicked');
          handleRedirect();
        }
      })
      .catch((error) => {
        trackEvent('trials.profile.error', { error: JSON.stringify(error) });
        setIsSubmitting(false);
      });

  return (
    <RoiModal
      primaryCta="Continue"
      onPrimaryCtaClick={handleSubmit}
      progress={33}
    >
      <ProfileContent isSubmitting={isSubmitting} />
      <Imagery />
    </RoiModal>
  );
};

export default Profile;
